import * as React from 'react';
import * as Styled from './styled';
import { ButtonBase, Fab, IconButton, PropTypes, Tooltip } from '@material-ui/core';
import { Delete, InsertDriveFile, PlayArrow, Stop } from '@material-ui/icons';
import { FabProgress } from './Timers';
import ImmutableTimer from '../../api/immutables/ImmutableTimer';
import { TKConsumer } from 'common/TKProvider';
import { TimeKeeperAssignment } from '../../api/types/types';
import { getTimerDurationTxt } from 'util/timer';
import { withTranslation } from 'react-i18next';
import { theme } from 'common/theme';

interface TimerLinkProps {
    buttonRef?: React.RefObject<HTMLElement>;
    timer: ImmutableTimer;
    onClick?: () => void;
    selected?: boolean;
    onStart: (fromKeyboard: boolean) => void;
    onStop: (fromKeyboard: boolean) => void;
    onDelete?: () => void;
    loadingId?: number;
    includeSubmitted: boolean;
    disableDelete?: boolean;
    actionColor?: PropTypes.Color;
    onAddNote?: () => void;
    isActiveToday?: boolean;
    // tslint:disable:no-any
    style?: any;
    t: any;
    // tslint:enable:no-any
}
interface TimerLinkState {
    durTxt: string;
}

class TimerLink extends React.Component<TimerLinkProps, TimerLinkState> {
    interval: NodeJS.Timeout;

    constructor(props: TimerLinkProps) {
        super(props);
        this.state = { durTxt: '' };
        if (props.timer.active) {
            this.interval = setInterval(this.timerTick, 250);
        }
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    getSnapshotBeforeUpdate(prevProps: TimerLinkProps) {
        if (prevProps.timer.active === this.props.timer.active) {
            return null;
        }
        clearInterval(this.interval);
        if (this.props.timer.active) {
            this.interval = setInterval(this.timerTick, 250);
        }
        return null;
    }
    timerTick = () => {
        const { timer, includeSubmitted } = this.props;
        this.setState({ durTxt: getTimerDurationTxt(timer, includeSubmitted) });
    }
    render() {
        const {
            timer,
            onStart,
            onStop,
            loadingId,
            onAddNote,
            disableDelete = false,
            style,
            includeSubmitted,
            buttonRef,
            t
        } = this.props;
        const dtxt = timer.active ? this.state.durTxt : getTimerDurationTxt(timer, includeSubmitted);
        return (
            <TKConsumer>
                { (tk: TimeKeeperAssignment) =>
                    <ButtonBase style={{width: '100%', height: '100%'}} tabIndex={-1}>
                        <Styled.CustomListItemContent
                            selected={this.props.selected}
                            style={style ? {height: style.height} : {height: '70px'}}
                            tabIndex={0}
                            data-timer-selected={this.props.selected ? 'true' : undefined}
                        >
                            <div>
                                <Tooltip title={t(timer.active ? 'action.pause' : 'action.start')} aria-hidden="true">
                                    <Styled.FabIcon
                                        buttonRef={buttonRef}
                                        disabled={!!loadingId || !tk.writable}
                                        onClick={(e) => {
                                            const fromKeyboard = !((e as unknown as PointerEvent).detail);
                                            e.stopPropagation();
                                            timer.active ? onStop!(fromKeyboard) : onStart!(fromKeyboard);
                                        }}
                                        size="medium"
                                        isLastModifiedToday={this.props.isActiveToday!}
                                        color={timer.active ? undefined : this.props.actionColor ? this.props.actionColor : 'secondary'}
                                        style={ !timer.active ? undefined :
                                            {backgroundColor: `${theme.primary.main}`, color: `${theme.white.main}`, minWidth: '48px'}
                                        }
                                        aria-label={t(timer.active ? 'action.pause' : 'action.start')}
                                    >
                                        {timer.active ? <Stop /> : <PlayArrow />}
                                        {(loadingId === timer.id) && <FabProgress size={55} color="secondary"/>}
                                    </Styled.FabIcon>
                                </Tooltip>
                            </div>
                            <Styled.ListText
                                aria-label={`${t('timer.name', {name: timer.name})}; ${t('timer.duration', {duration: dtxt})}`}
                                title={timer.name}
                                primary={timer.name}
                                secondary={dtxt}
                                primaryTypographyProps={{
                                    style: {
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        width: 'calc(100% - 40px)'
                                    }
                                }}
                            />
                            {tk.writable &&
                                <>
                                    {!disableDelete ? (
                                        <Styled.CustomSecondaryAction>
                                            <Tooltip title={t('delete', { ns: 'common' })} aria-hidden="true">
                                                <IconButton onClick={this.props.onDelete}>
                                                    <Delete />
                                                </IconButton>
                                            </Tooltip>
                                        </Styled.CustomSecondaryAction>
                                    ) : (
                                            <Styled.CustomSecondaryAction>
                                                {timer.active && <Tooltip title={t('active_chunk.icon.tooltip')}>
                                                    <IconButton
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            onAddNote!();
                                                        }}
                                                    >
                                                        <InsertDriveFile />
                                                    </IconButton>
                                                </Tooltip>}
                                            </Styled.CustomSecondaryAction>
                                        )}
                                </>
                            }
                        </Styled.CustomListItemContent>
                    </ButtonBase>
                }
            </TKConsumer>
        );
    }
}

export default withTranslation(['timers', 'common'])(TimerLink);